import React from 'react';

import { HighSignificanceIcon, LowSignificanceIcon, ModerateSignificanceIcon } from '@magoosh/lib/icons';
import { AnswerData } from 'types/answer';

import NoValueDash from '../no_value_dash';

interface Props {
  answer: AnswerData;
}

export default ({ answer }: Props) => {
  if (!answer.humanDifficulty) {
    return <NoValueDash />;
  } else if (answer.humanDifficulty === 'Unknown') {
    return <NoValueDash />;
  } else if (answer.humanDifficulty === 'Easy') {
    return (
      <>
        <LowSignificanceIcon fill="#9AA4B2" height={16} width={16} />
        {' '}{answer.humanDifficulty}
      </>
    );
  } else if (answer.humanDifficulty === 'Medium') {
    return (
      <>
        <ModerateSignificanceIcon fill="#9AA4B2" height={16} width={16} />
        {' '}{answer.humanDifficulty}
      </>
    );
  } else if (answer.humanDifficulty === 'Hard' || answer.humanDifficulty === 'Very Hard') {
    return (
      <>
        <HighSignificanceIcon fill="#9AA4B2" height={16} width={16} />
        {' '}{answer.humanDifficulty}
      </>
    );
  } else {
    return <>{answer.humanDifficulty}</>;
  }
};
